import apiConfig from 'src/integration/config/apiConfig';
import { useStore } from 'src/integration/store/store';
import useQueryKey from 'src/toolkit/utils/useQueryKey';
import useReactQueryJava from 'src/integration/api/useReactQueryJava';
import useErrorHandling from 'src/toolkit/utils/useErrorHandling';

const useFetchProfile = () => {
  const { configStore, profileStore } = useStore();
  const { setUser } = profileStore;
  const { jwtToken } = configStore;
  const { logoutOnError } = useErrorHandling();

  const response = useReactQueryJava<SimpleObject, SimpleObject>({
    endpoint: apiConfig.api.endpointsJava.profile,
    queryKey: useQueryKey('profile', [jwtToken]),
    method: 'GET',
    opts: {
      enabled: !!jwtToken,
      refetchOnWindowFocus: false,
      onSuccess: (data: SimpleObject) => {
        setUser(data);
      },
    },
  });

  return {
    ...response,
  };
};

export default useFetchProfile;
